module.exports = __webpack_public_path__ + "media/dashboard/assets/images/draggable-349345264a0615da82a571e9653756bc.svg";